
function megaMenuOpen($parent) {
  megaMenuClose();

  $parent.addClass("active");
  $parent.find(".megamenu-parent-link").attr("aria-expanded", "true");
  $("html").addClass("mega-menu--open");
  $parent.parents("ul").addClass("has-active");
  megaMenuMediaShow($parent[0]);
}

/* Metaobject mega menus (snippets/mega-menu.liquid) keep their images and
   video unloaded until the menu first opens: a closed panel is only
   visibility:hidden, which does not stop lazy images, and a video poster
   loads even inside display:none. The video streams over HLS through the
   global loader (assets/critical-global.js), plays muted and looped unless
   the visitor prefers reduced motion or paused it, and pauses when the
   menu closes. */
var megaMenuReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

function megaMenuMediaShow(item) {
  var menu = item && item.querySelector ? item.querySelector(".mega-menu") : null;
  if (!menu) return;
  menu.classList.add("is-revealed");
  menu.querySelectorAll("video[data-mega-menu-video]").forEach(function (video) {
    if (!video.hasAttribute("data-attached")) {
      video.setAttribute("data-attached", "");
      megaMenuVideoTrack(video);
      if (typeof window.attachResponsiveVideo === "function") window.attachResponsiveVideo(video);
    }
    if (!megaMenuReducedMotion.matches && !video.hasAttribute("data-user-paused")) megaMenuVideoPlay(video);
  });
}

function megaMenuMediaHide() {
  document.querySelectorAll(".mega-menu video[data-mega-menu-video]").forEach(function (video) {
    video.pause();
  });
}

function megaMenuVideoPlay(video) {
  // Until the stream is attached play() rejects; autoplay starts it once ready.
  video.autoplay = true;
  var played = video.play();
  if (played && typeof played.catch === "function") played.catch(function () {});
}

// Keeps the video's button in step: its name says what pressing it will do.
function megaMenuVideoTrack(video) {
  var button = video.parentNode.querySelector("[data-mega-menu-video-toggle]");
  if (!button) return;
  var sync = function () {
    var playing = !video.paused;
    button.classList.toggle("is-playing", playing);
    button.querySelector(".visually-hidden").textContent = playing ? button.dataset.labelPause : button.dataset.labelPlay;
  };
  video.addEventListener("play", sync);
  video.addEventListener("pause", sync);
}

document.addEventListener("click", function (e) {
  var button = e.target && e.target.closest ? e.target.closest("[data-mega-menu-video-toggle]") : null;
  if (!button) return;
  var video = button.parentNode.querySelector("video[data-mega-menu-video]");
  if (!video) return;
  if (video.paused) {
    video.removeAttribute("data-user-paused");
    megaMenuVideoPlay(video);
  } else {
    video.setAttribute("data-user-paused", "");
    video.autoplay = false;
    video.pause();
  }
});

/* Desktop mega menus. Each top link goes to its collection on click or
   Enter (snippets/header-bottom-nav.liquid); its menu opens:
   - on hover, with a mouse or trackpad ((hover: hover) and (pointer: fine))
   - on keyboard focus (:focus-visible), so Tab reaches the menu's links
   - on a first tap where there is no hover (touch screens); a second tap on
     the same link follows it
   Hover:
   - 150ms in, so a pass across the bar does not flash every menu; from one
     open menu to the next it switches at once.
   - 250ms out, so the pointer can cross from a link to its panel (a child
     of the same item).
   - Not during or right after a scroll: the slim band slides in under a
     resting pointer, and opening there would lock the page mid-scroll. A
     scroll also cancels an open still waiting on its delay (Safari sends
     no mouseleave when the band scrolls away). The next real pointer move
     opens it.
   - A menu holding keyboard focus is not closed by the pointer leaving.
   Focus leaving an open item for somewhere outside it closes it. Escape
   closes an open menu, however it was opened (WCAG 1.4.13), and returns
   focus to its link when focus was inside, without opening it again. */
(function () {
  var hover = window.matchMedia("(hover: hover) and (pointer: fine)");
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 250;
  var SCROLL_QUIET = 300;
  var openTimer = null;
  var closeTimer = null;
  var pending = null;
  var lastScroll = -Infinity;
  var quietFocus = null;

  function activeItem() {
    return document.querySelector(".header-bottom-nav-item.active");
  }

  function hasMenu(item) {
    var link = item.querySelector(".megamenu-parent-link");
    return !!link && !link.classList.contains("no-children") && !!item.querySelector(".header-megamenu-wrapper");
  }

  function holdsKeyboardFocus(item) {
    var focused = document.activeElement;
    return !!focused && item.contains(focused) && focused.matches(":focus-visible");
  }

  function cancelOpen() {
    window.clearTimeout(openTimer);
    pending = null;
  }

  function intend(item) {
    if (!hover.matches || pending === item) return;
    if (!hasMenu(item)) {
      cancelOpen();
      return;
    }
    window.clearTimeout(closeTimer);
    if (item.classList.contains("active")) {
      cancelOpen();
      return;
    }
    if (Date.now() - lastScroll < SCROLL_QUIET) return;
    cancelOpen();
    pending = item;
    openTimer = window.setTimeout(function () {
      pending = null;
      if (Date.now() - lastScroll < SCROLL_QUIET) return;
      megaMenuOpen($(item));
    }, activeItem() ? 0 : OPEN_DELAY);
  }

  function leave(item) {
    if (!hover.matches) return;
    if (pending === item) cancelOpen();
    if (!activeItem()) return;
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      var open = activeItem();
      if (open && !holdsKeyboardFocus(open) && !open.matches(":hover")) megaMenuClose();
    }, CLOSE_DELAY);
  }

  window.addEventListener(
    "scroll",
    function () {
      lastScroll = Date.now();
      cancelOpen();
    },
    { passive: true },
  );

  document.querySelectorAll(".header-bottom-nav-item").forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      intend(item);
    });
    item.addEventListener("mousemove", function () {
      intend(item);
    });
    item.addEventListener("mouseleave", function () {
      leave(item);
    });
    item.addEventListener("focusout", function (e) {
      if (!item.classList.contains("active") || (e.relatedTarget && item.contains(e.relatedTarget))) return;
      window.setTimeout(function () {
        if (item.classList.contains("active") && !item.contains(document.activeElement) && !item.matches(":hover")) {
          megaMenuClose();
        }
      }, 0);
    });

    if (!hasMenu(item)) return;
    var link = item.querySelector(".megamenu-parent-link");
    // A menu held by the Home page link has a button for a trigger
    // (snippets/mega-menu.liquid). It goes nowhere, so a click, tap, Enter
    // or Space toggles the menu; only the click that usually follows a
    // hover-open leaves it open while the pointer is on it.
    var holder = link.tagName === "BUTTON";
    link.addEventListener("click", function (e) {
      if (holder) {
        e.preventDefault();
        cancelOpen();
        window.clearTimeout(closeTimer);
        if (!item.classList.contains("active")) {
          megaMenuOpen($(item));
        } else if (!(hover.matches && item.matches(":hover"))) {
          megaMenuClose();
        }
        return;
      }
      if (hover.matches || item.classList.contains("active")) return;
      e.preventDefault();
      cancelOpen();
      megaMenuOpen($(item));
    });
    link.addEventListener("focus", function () {
      if (quietFocus === link || item.classList.contains("active") || !link.matches(":focus-visible")) return;
      cancelOpen();
      window.clearTimeout(closeTimer);
      megaMenuOpen($(item));
    });
    link.addEventListener("blur", function () {
      if (quietFocus === link) quietFocus = null;
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" && e.keyCode !== 27) return;
    var open = activeItem();
    if (!open) return;
    var hadFocus = open.contains(document.activeElement);
    cancelOpen();
    window.clearTimeout(closeTimer);
    megaMenuClose();
    if (hadFocus) {
      var link = open.querySelector(".megamenu-parent-link");
      if (link) {
        quietFocus = link;
        link.focus();
      }
    }
  });
})();

$(".megamenu-close-button").click(function (e) {
  e.preventDefault();
  megaMenuClose();
});

function megaMenuClose() {
  $("html").removeClass("mega-menu--open");
  var $activeItems = $(".header-bottom-nav-item.active");
  var $list_parent = $(".header-bottom-nav-ul");

  $list_parent.removeClass("has-active");
  $activeItems.removeClass("closing");
  $activeItems.removeClass("active");
  $(".megamenu-parent-link[aria-controls]").attr("aria-expanded", "false");
  megaMenuMediaHide();

  //dirty hack for accessibe to close the megamenu
  $activeItems.trigger("click");

  setTimeout(function () {}, 300);
}





$(".parent_has_submenu").click(function (e) {
  var $parent = $(this).parents(".fixed-nav-menu-item");
  e.preventDefault();
  if ($parent.hasClass("active")) {
    $parent.removeClass("active");
    $(this).attr("aria-expanded", "false");
  } else {
    $("#fixed-menu").addClass("submenu-open");
    if (this.hasAttribute("aria-controls")) drawerPanelOpen(this);
    var $btn = $(this);
    setTimeout(function () {
      $parent.addClass("active");
    }, 100);
    $btn.attr("aria-expanded", "true");
    $(".header-content .toggle-menus").hide();
  }
});

// role="button" elements must also activate on Space (anchors only fire click on Enter)
$(".parent_has_submenu").on("keydown", function (e) {
  if (e.key === " " || e.keyCode === 32) {
    e.preventDefault();
    $(this).click();
  }
});

// A11y: the in-menu skip link must actually MOVE focus to the nav list (an in-page
// href alone only scrolls; it does not move screen-reader/keyboard focus).
$(document).on("click", ".js-skip-to-menu", function (e) {
  e.preventDefault();
  var list = document.getElementById("fixed-nav-menu-list");
  if (!list) return;
  var firstItem = list.querySelector("a, button");
  (firstItem || list).focus();
});

function fixedNavSubMenuClose() {
  var $active_nav = $(".fixed-nav-menu-item.active");
  var trigger = drawerPanel.trigger;
  var panel = drawerPanel.panel;
  drawerPanelRelease();

  $active_nav.find(".parent_has_submenu").attr("aria-expanded", "false");
  $active_nav.addClass("closing");
  setTimeout(function () {
    $("#fixed-menu").removeClass("submenu-open");
    if (trigger) {
      panel.hidden = true;
      megaMenuMediaHide();
      trigger.focus();
      drawerPanel.trigger = null;
      drawerPanel.panel = null;
    } else {
      $(".fixed-nav-menu-list").focus();
    }
    $active_nav.removeClass("closing");
    $active_nav.removeClass("active");
    $(".header-content .toggle-menus").show();
  }, 800);
}

$(".js-fixed-nav-back").click(function (e) {
  fixedNavSubMenuClose();
});

/* Side menu sub panels that opt in with aria-controls (the metaobject mega
   menus, snippets/mega-menu.liquid). The panel stays hidden until opened, so
   none of its images load before. On open its media is revealed, focus moves
   to its heading and the rest of the side menu goes inert, so Tab and screen
   readers stay in the panel. Back returns focus to the trigger, Escape closes
   only the panel (a second Escape closes the side menu), and closing the
   side menu (theme.js closeMenu) resets it. Panels without aria-controls
   behave as before. */
var drawerPanel = { trigger: null, panel: null, inert: [] };

function drawerPanelOpen(trigger) {
  var panel = document.getElementById(trigger.getAttribute("aria-controls"));
  if (!panel) return;
  var item = trigger.closest(".fixed-nav-menu-item");
  var root = item.closest(".fixed-menu-left") || document.getElementById("fixed-menu");
  panel.hidden = false;
  megaMenuMediaShow(item);
  drawerPanelRelease();
  drawerPanel.trigger = trigger;
  drawerPanel.panel = panel;
  // The trigger, the other items, and the siblings of every ancestor up to the side menu.
  var hide = [trigger];
  for (var node = item; node && node !== root && node.parentElement; node = node.parentElement) {
    Array.prototype.forEach.call(node.parentElement.children, function (sibling) {
      if (sibling !== node) hide.push(sibling);
    });
  }
  hide.forEach(function (el) {
    if (el.inert) return;
    el.inert = true;
    drawerPanel.inert.push(el);
  });
  window.setTimeout(function () {
    var heading = panel.querySelector("[tabindex='-1']");
    if (heading) heading.focus({ preventScroll: true });
  }, 150);
}

function drawerPanelRelease() {
  drawerPanel.inert.forEach(function (el) {
    el.inert = false;
  });
  drawerPanel.inert = [];
}

function drawerPanelReset() {
  drawerPanelRelease();
  if (!drawerPanel.panel) return;
  drawerPanel.trigger.setAttribute("aria-expanded", "false");
  drawerPanel.panel.hidden = true;
  megaMenuMediaHide();
  drawerPanel.trigger = null;
  drawerPanel.panel = null;
}

(function () {
  var fixedMenu = document.getElementById("fixed-menu");
  if (!fixedMenu) return;
  fixedMenu.addEventListener("keydown", function (e) {
    if ((e.key !== "Escape" && e.keyCode !== 27) || !drawerPanel.panel) return;
    e.stopPropagation();
    fixedNavSubMenuClose();
  });
})();


//header logo video
$(document).ready(function () {
  const video = document.querySelector(".logo-video-container video");

  const videoContainerEl = document.querySelector(".logo-video-container");

  if (video) {
    video.addEventListener(
      "loadeddata",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener(
      "canplay",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener(
      "canplaythrough",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener("ended", function () {
      //console.log("video ended");
      //videoContainerEl.classList.remove("video-loaded");
    });

    playLogoVideo();

    video.removeAttribute("controls");
  }

  function playLogoVideo() {
    video.play();
    //console.log("play");
    setTimeout(function () {
      videoContainerEl.classList.add("video-loaded");
    }, 500);
  }

  $(".nav-menu.recent-additions").each(function () {
    var handle = $(this).data("handle");
    var _this = $(this);
    let url = window.Shopify.routes.root + "collections/" + handle + "?view=alternate&sort_by=created-descending";

    $.ajax({
            type: "GET",
            url: url,
            success: function (result) {
            var json = JSON.parse(result);
            let limit = 3;
            let cls = "link-animate-underline";
            if (_this.hasClass("fixed-nav-submenu-item-list")) {
                cls = "";
            }
            for (let i = 0; i < limit && i < json.products.length; i++) {
                let product = json.products[i];
                var item = `<li class="megamenu-grandchild-item"><a class="${cls}" href="${product.url}">${product.title}</a></li>`;
                _this.append(item);
            }
            },
            error: function () {
            _this.hide();
            },
        });
    });

    $(".nav-menu.best-sellers").each(function () {
    var handle = $(this).data("handle");
    var _this = $(this);
    let url = window.Shopify.routes.root + "collections/" + handle + "?view=alternate&sort_by=best-selling";
    $.ajax({
            type: "GET",
            url: url,
            success: function (result) {
            var json = JSON.parse(result);
            let limit = 5;
            let cls = "link-animate-underline";
            if (_this.hasClass("fixed-nav-submenu-item-list")) {
                cls = "";
            }
            
            for (let i = 0; i < limit && i < json.products.length; i++) {
                let product = json.products[i];
                var item = `<li class="megamenu-grandchild-item"><a class="${cls}" href="${product.url}">${product.title}</a></li>`;
                _this.append(item);
            }

            /*hide parent link if products == 0 
            if(json.products.length == 0){
                _this.parents('.header-bottom-nav-item').hide();
                _this.parents('.fixed-nav-menu-item').hide();
            }
            */
            },
            error: function () {
            _this.hide();
            },
        });
    });
});